import { ExternalAppId } from "../../generated/enums"
import { IOmniaShell } from "../../shell"
import { showOkCancel } from "../../shell/msgbox/msgbox"
import { RoleId } from "../../user"
import { AppConnectionMode } from "../types"
import { ConnectionVM } from "./vm"

/** @internal */
export function confirmDisconnect(cn: ConnectionVM, shell: IOmniaShell) {

    const name = cn.name

    const basic = cn.provider.connectionMode == AppConnectionMode.BasicAuth

    const msg = `<p>You are about to disconnect your ${name} account from OmniaHub.</p>`
        + (basic ? "" : `<p>Please note that to be fully disconnected, you will also have to delete this connection in ${name}.</p>`)

    const title = "Disconnection confirmation"

    return showOkCancel(shell, msg, title).then(r => !!r)

}

/** @internal */
export function confirmSyncReset(cn: ConnectionVM, shell: IOmniaShell, canKeepData: boolean) {

    return cn.checkSyncData().then(r => {

        if (!r) {
            return "delete"
        }

        if (canKeepData) {

            const admin = shell.getSession().currentUserRole <= RoleId.Admin
            const glgm = cn.provider.appId == ExternalAppId.Glgm

            if (admin && glgm) {
                return confirmSyncResetAdmin(cn, shell)
            }

        }

        const msg = cn.orgMsg.resetLinks.prompt
        const title = cn.orgMsg.resetLinks.title

        return showOkCancel(shell, msg, title).then(ok => ok ? "delete" : false)

    })

}

/** @internal */
export function confirmSyncResetAdmin(cn: ConnectionVM, shell: IOmniaShell) {

    const args = {
        data: undefined as "delete" | "keep",
        title: cn.orgMsg.resetLinks.title
    }

    return shell.showMessageBox({
        templateUrl: "shared/apps/manage/disconnect.html",
        arguments: args
    }).then(ok => ok ? args.data : false)

}
